import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  cardRoot: {
    borderRadius: 8,
    width: 180,
    height: 100,
    '& > button': {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    marginRight: 32,
    ['@media (max-width:960px)']: {
      marginBottom: theme.spacing(2.75),
    },
    boxShadow: 'none',
    border: `1px solid ${theme.palette.bgSecondary.main}`,
  },
  conncectwiseLogo: {
    '& .MuiCardMedia-img ': {
      objectFit: 'contain',
    },
    '& button:hover': {
      backgroundColor: 'inherit',
    },
  },
  imageList: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: theme.palette.common.white,
  },

  selected: {
    border: `2px solid ${theme.palette.button.secondary}`,
  },

  disable: {
    opacity: '0.3',
  },

  divider2: {
    backgroundColor: theme.palette.dividers.main,
    height: '2px',
  },
  crmSubTitle: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
  selectCrmContainer: {
    margin: theme.spacing(0, 0, 4, 4),
  },
}))
